import { put, call, takeLatest } from 'redux-saga/effects';
import { ChatScheduleAction, ChatScheduleTypes, DateRange } from '../types';
import { deleteSchedule, getSchedules, scheduleErrorLoading, scheduleErrorSaving, upsertSchedule } from '../actions';
import strings from '../../../resources/strings';
import { createScheduleFromRange } from '../utils';
import {
    addScheduleFirebase,
    deleteScheduleFirebase,
    getScheduleListFirebase,
    updateScheduleFirebase,
} from '../repository';

export function* requestAddScheduleSaga(props: ChatScheduleAction<DateRange>): unknown {
    try {
        const schedule = createScheduleFromRange(props.payload);
        const addedSchedule = yield call(addScheduleFirebase, schedule);
        yield put(upsertSchedule(addedSchedule));
    } catch (err: unknown) {
        yield put(scheduleErrorSaving(`${strings.chatSchedulePage.errors.addError}, error: ${err}`));
    }
}

export function* requestDeleteScheduleSaga(props: ChatScheduleAction<string>): unknown {
    try {
        yield call(deleteScheduleFirebase, props.payload);
        yield put(deleteSchedule(props.payload));
    } catch (err: unknown) {
        yield put(scheduleErrorSaving(`${strings.chatSchedulePage.errors.deleteError}, error: ${err}`));
    }
}

export function* requestUpdateScheduleSaga(props: ChatScheduleAction<{ range: DateRange; id: string }>): unknown {
    try {
        const { range, id } = props.payload;
        const schedule = createScheduleFromRange(range);
        schedule.id = id;
        yield call(updateScheduleFirebase, schedule);
        yield put(upsertSchedule(schedule));
    } catch (err: unknown) {
        yield put(scheduleErrorSaving(`${strings.chatSchedulePage.errors.updateError}, error: ${err}`));
    }
}

export function* requestGetSchedulesSaga(props: ChatScheduleAction<DateRange>): unknown {
    try {
        const schedules = yield call(getScheduleListFirebase, props.payload);
        yield put(getSchedules(schedules, props.payload));
    } catch (err: unknown) {
        yield put(scheduleErrorLoading(`${strings.chatSchedulePage.errors.getError}, error: ${err}`));
    }
}
export default [
    takeLatest(ChatScheduleTypes.REQUEST_ADD_SCHEDULE, requestAddScheduleSaga),
    takeLatest(ChatScheduleTypes.REQUEST_DELETE_SCHEDULE, requestDeleteScheduleSaga),
    takeLatest(ChatScheduleTypes.REQUEST_UPDATE_SCHEDULE, requestUpdateScheduleSaga),
    takeLatest(ChatScheduleTypes.REQUEST_GET_SCHEDULES, requestGetSchedulesSaga),
];
